import { useState } from "react";
import api from "@/auth/api";
import { alertError, alertSuccess } from "@/components/Alert";

const Add = ({ agencyList, onSuccess, countryList, brandList }) => {

  const [formData, setFormData] = useState({
    agency: "",
    title: "",
    detail: "",
    // points: "",
    value: "",
    productImage: null,
    country: "",
    brand: ""
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, val]) => {
        data.append(key, val);
      });

      await api.post("/redeem/panel/gift/card", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alertSuccess("Gift Card added successfully!");
      setFormData({
        agency: "",
        title: "",
        detail: "",
        // points: "",
        value: "",
        productImage: null,
        country: "",
        brand: ""
      })
      onSuccess()
    } catch (err) {
      console.error(err);
      alertError("Failed to add Gift Card.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto border rounded-lg p-2 space-y-2 text-sm"
    >
      {/* <h2 className="text-base font-semibold mb-2">Add New Product</h2> */}

      {/* Row 1: Agency + Title */}
      <div className="flex gap-2">
        <div className="flex-1">
          <label className="block mb-1">Agency</label>
          <select
            name="agency"
            value={formData.agency}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          >
            <option value="" disabled>Select</option>
            {agencyList.map((m) => {
              return <option value={m.id}>{m.agencyName}</option>
            })}
          </select>
        </div>
        <div className="flex-1">
          <label className="block mb-1">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          />
        </div>
      </div>
      <div className="flex-1">
        <label className="block mb-1">Detail</label>
        {/* <input
          type="text"
          name="detail"
          value={formData.detail}
          onChange={handleChange}
          required
          className="w-full border px-2 py-1 rounded"
        /> */}
        <textarea
        name="detail"
        value={formData.detail}
        onChange={handleChange}
        required
        rows={2}   // ✅ 3 lines height
        className="w-full border px-2 py-1 rounded resize-none"
      />
      </div>
      {/* Row 2: Detail + Points */}
      <div className="flex gap-2">

        {/* <div className="flex-1">
          <label className="block mb-1">Points</label>
          <input
            type="number"
            name="points"
            value={formData.points}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          />
        </div> */}
        <div className="flex-1">
          <label className="block mb-1">Value</label>
          <input
            type="number"
            name="value"
            value={formData.value}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <div className="flex-1">
          <label className="block mb-1">Country</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          >
            <option value="" disabled>Select</option>
            {countryList.map((m) => {
              return <option value={m.id}>{m.title}</option>
            })}
          </select>
        </div>
        <div className="flex-1">
          <label className="block mb-1">Brand</label>
          <select
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            required
            className="w-full border px-2 py-1 rounded"
          >
            <option value="" disabled>Select</option>
            {brandList.map((m) => {
              return <option value={m.id}>{m.name}</option>
            })}
          </select>
        </div>
      </div>

      {/* Product Image */}
      <div>
        <label className="block">Product Image</label>
        <input
          type="file"
          name="productImage"
          accept="image/*"
          onChange={handleChange}
          required
          className="w-full border px-2 py-1 rounded"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white py-1.5 rounded hover:bg-[var(--mainColHover)]"
      >
        Submit
      </button>
    </form>
  );
};

export default Add;
